import React from 'react';

import UserContext from './userContext';
import useUserProvider from './useUserProvider';

interface UserProviderProps {
	children: any;
}

const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
	const {
		isLoggedIn,
		logoutUser,
		loginUser,
		loginOutsourceUser,
		user,
		roleConfig,
		permissionsConfig,
		checkIfLoggedIn,
		getACLUsers,
		aclUsers
	} = useUserProvider();

	return (
		<UserContext.Provider
			value={{
				isLoggedIn,
				logoutUser,
				loginUser,
				loginOutsourceUser,
				user,
				roleConfig,
				permissionsConfig,
				checkIfLoggedIn,
				getACLUsers,
				aclUsers
			}}>
			{children}
		</UserContext.Provider>
	);
};

export default UserProvider;
